<template>
    <router-view />
</template>

<script>
    export default {
        name: 'App'
    };
</script>

<style lang="scss">
    .toast_custom-font-error {
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 400 !important;
        background-color: #eb445a !important;
    }

    .toast_custom-font-info {
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 400 !important;
        background-color: #1e96fc !important;
    }
</style>